import { OperationMS } from '../../types';
import { CommandeAnalyse, TechNotes, SignataireSelection } from './types';
import { isExpire } from './statutOffre';

// Construction des corps d'API de l'Analyse. Les noms de champs sont en snake_case
// (contrat backend) et ne sont PAS renommes. Le `selected` derive du retenu unique
// (attribution.resolveWinnerId) -> jamais de divergence payload/affichage.

export interface CommandeNotePayload {
  commande_id: number | undefined;
  id_note_technique: number | undefined;
  selected: boolean;
  note_operationnel: number;
  commentaire_operationnel: string;
  description_operationnel: string;
  note_humain: number;
  commentaire_humain: string;
  description_humain: string;
  note_environnement: number;
  commentaire_environnement: string;
  description_environnement: string;
}

export interface NotePayload {
  operation_id: number;
  commandes: CommandeNotePayload[];
}

export interface ValidatePayload extends NotePayload {
  id_signataire?: number;
  type_signataire?: string;
}

// Une ligne de note. `blankExpired` vide commentaires/descriptions des offres expirees
// (comportement du PUT /note legacy) ; le POST /validate ne les vidait pas.
const buildCommandeNote = (
  commande: CommandeAnalyse,
  techNotes: TechNotes,
  winnerId: number | null,
  blankExpired: boolean,
): CommandeNotePayload => {
  const notes = techNotes[String(commande.id)] || {};
  const expired = blankExpired && isExpire(commande.id_status);
  const text = (value?: string): string => (expired ? '' : value ?? '');

  const organisation = notes.organisation || {};
  const moyens = notes.moyens || {};
  const social = notes.social || {};

  return {
    commande_id: commande.id,
    id_note_technique: commande.id_note_technique,
    selected: commande.id !== undefined && String(commande.id) === String(winnerId),
    note_operationnel: organisation.note ?? 0,
    commentaire_operationnel: text(organisation.commentaire),
    description_operationnel: text(organisation.description),
    note_humain: moyens.note ?? 0,
    commentaire_humain: text(moyens.commentaire),
    description_humain: text(moyens.description),
    note_environnement: social.note ?? 0,
    commentaire_environnement: text(social.commentaire),
    description_environnement: text(social.description),
  };
};

const commandesAnalyse = (operation: OperationMS): CommandeAnalyse[] =>
  (operation.commandes ?? []) as CommandeAnalyse[];

// Corps PUT /subsequents/operation/:id/note (enregistrer les notes + le retenu).
export const buildNotePayload = (
  operation: OperationMS,
  techNotes: TechNotes,
  winnerId: number | null,
): NotePayload => ({
  operation_id: operation.id,
  commandes: commandesAnalyse(operation).map((c) => buildCommandeNote(c, techNotes, winnerId, true)),
});

// Corps POST /subsequents/operation/:id/validate (cloture : notes + retenu + signataire).
export const buildValidatePayload = (
  operation: OperationMS,
  techNotes: TechNotes,
  winnerId: number | null,
  signataire: SignataireSelection,
): ValidatePayload => ({
  operation_id: operation.id,
  id_signataire: signataire.id_signataire,
  type_signataire: signataire.type_signataire,
  commandes: commandesAnalyse(operation).map((c) => buildCommandeNote(c, techNotes, winnerId, false)),
});
